import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { BaseDtoSearchService } from './base-dto.service';
import { SearchUserDto, SearchUsersParameters, UserClient, UserDto } from './reporting-api-proxies';

@Injectable({
    providedIn: 'root'
})
export class ReportingUserService extends BaseDtoSearchService {
    constructor(private readonly client: UserClient) {
        super();
    }

    async search(filterText: string): Promise<SearchUserDto[]> {
        const body = {
            filterText,
            isActive: true
        } as SearchUsersParameters;
        const response = await lastValueFrom(this.client.userSearchUsers(body));

        return response;
    }

    async searchUsers(body: SearchUsersParameters): Promise<SearchUserDto[]> {
        return await lastValueFrom(this.client.userSearchUsers(body));
    }

    async getById(id: number): Promise<UserDto> {
        return await lastValueFrom(this.client.userGetById(id));
    }

    async getByIds(userIds: number[]): Promise<SearchUserDto[]> {
        const response = await lastValueFrom(this.client.userSearchUsers({ userIds } as SearchUsersParameters));
        return response;
    }
}
